import { useEffect, useState } from "react";
import updateFlightSetting from "../../../controllers/settings/supplier/updateFlightSetting";
import { enqueueSnackbar } from "notistack";
import AirlinesInput from "../../../components/form/AirlinesInput";
import Button1 from "../../../components/form/Button1";
import Icon from "../../../components/HOC/Icon";

export default function TicketingAuthorizedAirlined({data:defData,close}) {
  const [openAirlines,setOpenAirlines] = useState(false);
  const [data,setData] = useState(defData||[])
  const [loadings,setLoadings] = useState({airlinesUpdate: false})

  useEffect(() => {
    setData(defData)
  },[defData])
  
  
  const handleAirlineUpdate = async () => {
    const ticketingAuthorizedAirlines = data;

    setLoadings({ ...loadings, airlinesUpdate: true })
    const res = await updateFlightSetting({ ticketingAuthorizedAirlines });
    setTimeout(() => setLoadings({ ...loadings, airlinesUpdate: false }), 1000)
    if (res.return) {
      enqueueSnackbar('Successful', { variant: 'success' })
      // reload && reload()
    } else enqueueSnackbar(res.msg, { variant: 'error' })
  }

    
	function handleAirlineSelection(airlines) {
    // return console.log(airlines)
		if(!airlines)
			return;
		let list = airlines;
		if(!Array.isArray(list))
			list = [list]

    setData([...data,...list]?.map(obj => obj?.id || obj))
		// setOpenAirlines({...openAirlines,airline: '',list: [...(openAirlines?.list||[]),...list]})
	}

	function handleAirlineDelete(airline) {
		setData(data?.filter(val => val !== airline))
		// setOpenAirlines({...openAirlines,list: (openAirlines?.list||[])?.filter(obj => obj?.id !== airline)})
	}

  console.log(data)
  
  return (
    <div>
      {/* <button className='btn-light'
       onClick={() => setOpenAirlines(true)}
      >Ticketing Authorized Airlines</button> */}
      
      {/* <Modal3 open={openAirlines} setOpen={() => setOpenAirlines(false)} title='Ticketing Authorized Airlines'> */}
        <div className='flex flex-col gap-4 p-4'>
          <div>Airlines authorized for ticketing</div>
          <div className='flex gap-4 items-center'>
            {(data||[])?.map(airline => 
              <button key={airline} className='border rounded-md p-1 px-2 flex items-center gap-2'>
                <span>{airline}</span>
                <button onClick={() => handleAirlineDelete(airline)}><Icon icon='mdi:delete' className='text-red-500' /></button>
              </button>
            )}
          </div>
          <AirlinesInput val={openAirlines?.airline||''} returnData={(airlines) => {
            handleAirlineSelection(airlines)}
          } />
          <div className='flex gap-4 justify-between'>
            <div>
              <Button1 variant='outlined' onClick={() => close && close(false)}>Cancel</Button1>
            </div>
            <Button1 loading={loadings?.airlinesUpdate} onClick={() => handleAirlineUpdate()}>Update</Button1>
          </div>
        </div>
      {/* </Modal3> */}
    </div>
  )
}
